module.exports = __webpack_public_path__ + "static/media/booth-border.c97d3033.svg";